import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const labelCls =
  "text-zinc-500 text-xs font-bold uppercase tracking-[0.15em]";
const inputCls =
  "mt-1 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white";

export default function AnamnesiPersonalSection({ form, onChange }) {
  return (
    <>
      <p className="label-overline mb-3">DATI PERSONALI</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div>
          <Label className={labelCls}>Nome</Label>
          <Input
            value={form.first_name}
            onChange={(e) => onChange("first_name", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-first_name"
          />
        </div>
        <div>
          <Label className={labelCls}>Cognome</Label>
          <Input
            value={form.last_name}
            onChange={(e) => onChange("last_name", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-last_name"
          />
        </div>
        <div>
          <Label className={labelCls}>Email</Label>
          <Input
            type="email"
            value={form.email}
            onChange={(e) => onChange("email", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-email"
          />
        </div>
        <div>
          <Label className={labelCls}>Telefono</Label>
          <Input
            value={form.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-phone"
          />
        </div>
        <div>
          <Label className={labelCls}>Data di nascita</Label>
          <Input
            type="date"
            value={form.date_of_birth}
            onChange={(e) => onChange("date_of_birth", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-date_of_birth"
          />
        </div>
        <div>
          <Label className={labelCls}>Sesso</Label>
          <Select
            value={form.gender || "unset"}
            onValueChange={(v) => onChange("gender", v === "unset" ? "" : v)}
          >
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="anamnesi-gender"
            >
              <SelectValue placeholder="Seleziona" />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="unset" className="text-white">-</SelectItem>
              <SelectItem value="M" className="text-white">Maschio</SelectItem>
              <SelectItem value="F" className="text-white">Femmina</SelectItem>
              <SelectItem value="Altro" className="text-white">Altro</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </>
  );
}
